/* eslint-disable no-unused-vars */

import SectionContainer from '@components/section-container';
import React from 'react';
import style from '../../workorder.module.scss';
import PhotoComponent from '@components/photo-component';
import DocumentsCard from '@components/documents-card';

import { store } from 'redux/store';

const PhotoDocumentSubSection = ({ photos, documents, isImagesFailedDuringFetch = false }) => {
  const { picklists } = store.getState();
  const { picklistsMap } = picklists;

  if (!photos?.length && !documents?.length) {
    return <></>;
  }

  return (
    <div>
      <SectionContainer
        text={'Photos/Documents'}
        subSection
        headerClassName={`${style.utSectionOfPhotos}`}
      >
        {/* <div className={style.utPhotoDocumentContainer}>dsds</div> */}
        {photos?.length > 0 && (
          <div
            style={{
              width: '100%'
            }}
          >
            <div className={style.photoCard}>
              <h6>{'photos'}</h6>

              <div className={style.grid2} style={{ marginTop: '16px' }}>
                {photos?.map((card, index) => {
                  return (
                    <PhotoComponent
                      key={index}
                      photoId={card?.id || index}
                      imageUrl={card?.imageURL || null}
                      categoryValue={picklistsMap?.[card?.category]?.value || 'Uncategorized'}
                      captionValue={card?.caption || ''}
                      viewableImages
                      editable={false}
                      isImagesFailedDuringFetch={isImagesFailedDuringFetch}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {documents?.length > 0 && (
          <div
            style={{
              width: '100%'
            }}
          >
            <div className={style.photoCard}>
              <h6>{'documents'}</h6>

              {documents?.map((doc, index) => {
                return (
                  <DocumentsCard
                    documentCategory={{
                      fileName: doc?.fileName || '',
                      category: doc?.category
                    }}
                    key={index}
                    picklistsMap={picklistsMap}
                    noAction={true}
                    pdfUrl={doc?.files || null}
                    downloaded={true}
                    isImagesFailedDuringFetch={isImagesFailedDuringFetch}
                  />
                );
              })}
            </div>
          </div>
        )}
      </SectionContainer>
    </div>
  );
};

export default PhotoDocumentSubSection;
